import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async'; // 1. Import this
import router from './routes/Route';

const queryClient = new QueryClient()
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        {/* 2. Wrap your RouterProvider with HelmetProvider */}
        <RouterProvider router={router} />
      </QueryClientProvider>
    </HelmetProvider>

  </React.StrictMode>
);

reportWebVitals();